import { render, staticRenderFns } from "./ContactEdit.vue?vue&type=template&id=3968caf0"
import script from "./ContactEdit.vue?vue&type=script&lang=ts"
export * from "./ContactEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3968caf0')) {
      api.createRecord('3968caf0', component.options)
    } else {
      api.reload('3968caf0', component.options)
    }
    module.hot.accept("./ContactEdit.vue?vue&type=template&id=3968caf0", function () {
      api.rerender('3968caf0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/contacts/ContactEdit.vue"
export default component.exports